// Spot sizes on phones and on larger screens
const MOBILE_SPOT = { w: 48, h: 12, rx: 23.5, ry: 5.5, stroke: 0.75 };
const SPOT = { w: 102, h: 32, rx: 44.5, ry: 9.5, stroke: 1.5 };

// Flat spot under the card: dark fill and a hairline, like the empty card
const PositionSVG = ({ mobile }: { mobile: boolean }) => {
  const { w, h, rx, ry, stroke } = mobile ? MOBILE_SPOT : SPOT;
  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx={w / 2}
        cy={h / 2}
        rx={rx}
        ry={ry}
        strokeWidth={stroke}
        className="fill-background stroke-edge-strong"
      />
    </svg>
  );
};

export const Position = ({
  children,
  tabletOrLargerMode,
}: {
  children: React.ReactNode;
  tabletOrLargerMode: boolean;
}) => {
  return (
    <div className="relative flex flex-row items-center gap-1">
      <PositionSVG mobile={!tabletOrLargerMode} />
      <div className="absolute inset-x-0 flex items-center justify-center text-gray-200 font-medium text-xtiny desktop:text-xxs large-desktop:text-[11px]">
        {children}
      </div>
    </div>
  );
};
